export default {
    COMPLETE: 'COMPLETE',
    IN_PROGRESS: 'IN_PROGRESS',
    SECURITY_CHECK_FAILED: 'SECURITY_CHECK_FAILED',
    FAILED: 'FAILED'
};
